// src/store/selectors.js
import { createSelector } from 'reselect';

const loginState = (state) => state.Login;
const googleLoginState = (state) => state.googleLogin;
const selectLayoutState = (state) => state.Layout;

// User-related selectors
const selectUserState = (state) => state.user;

// New selector for layoutType
export const selectLayoutType = createSelector(
  [selectLayoutState],
  (layout) => layout.layoutType
);

export const getLoginError = createSelector(
  [loginState],
  (login) => login.error
);

export const getLoginLoading = createSelector(
  [loginState],
  (login) => login.loading
);

export const getIsLoggedIn = createSelector(
  [loginState],
  (login) => login.isLoggedIn
);

export const getGoogleError = createSelector(
  [googleLoginState],
  (googleLogin) => googleLogin.error
);

export const getGoogleLoading = createSelector(
  [googleLoginState],
  (googleLogin) => googleLogin.loading
);

export const getGoogleLoggedIn = createSelector(
  [googleLoginState],
  (googleLogin) => googleLogin.isGoogleLoggedIn
);

export const isLoginStateClear = (state) => {
  return !state.Login.loading && !state.Login.isLoggedIn && !state.Login.error;
};

// Selector to check if the Google login state is clear
export const isGoogleLoginStateClear = (state) => {
  return !state.googleLogin.loading && !state.googleLogin.isGoogleLoggedIn && !state.googleLogin.error;
};


/*---- selectLayoutState ----*/
export const selectLayoutSettings = createSelector(
  [selectLayoutState],
  (layout) => ({
    showHeader: layout.showHeader ?? true,     // ← fallback to true
    showFooter: layout.showFooter ?? true,
    showRightSidebar: layout.showRightSidebar ?? false,

    isPreloader: layout.isPreloader,
    layoutModeType: layout.layoutModeType,
    leftSideBarThemeImage: layout.leftSideBarThemeImage,
    leftSideBarType: layout.leftSideBarType,
    layoutWidth: layout.layoutWidth,
    topbarTheme: layout.topbarTheme,
    leftSideBarTheme: layout.leftSideBarTheme,
  })
);
/*---- selectLayoutState ----*/

/*---- selectUserState ----*/
export const selectUserData = createSelector(
  [selectUserState],
  (user) => ({
    userData: user.userData,
    tokenNotFound: user.tokenNotFound,
  })
);
/*---- selectUserState ----*/

export const selectTopicsForStore = (state, storeId) => {
  const store = state.storeDetails.stores[storeId];
  if (!store) return [];

  return store.topicIds
    .map(id => state.topicDetails.topics[id]?.topicInfo)
    .filter(Boolean); // filter out nulls if not yet loaded
};

export const selectQuestionSetsForTopic = (state, topicId) => {
  const topic = state.topicDetails.topics[topicId];
  if (!topic) return [];

  return topic.questionSetIds
    .map(id => state.questionSetDetails?.questionSets[id] || [])
    .filter(Boolean); // filter out nulls if not yet loaded
};







